import React, { useRef, useState } from 'react';

import AdyenDropInContainer from 'containers/AdyenDropInContainer';
import AdyenFormWrapper from 'components/pages/checkout/CheckoutView/Payment/paymentMethods/Adyen/AdyenFormWrapper';
import Heading from 'components/text/Heading';
import LoadingIcon from 'assets/icons/Loading';
import PropTypes from 'prop-types';
import ShippingForm from 'components/pages/checkout/CheckoutView/Payment/Shipping';
import { above } from 'utils/mediaqueries';
import colors from 'config/theme/colors';
import { inServer } from 'config/constants';
import { scrollTo } from 'utils/scrollFunctions';
import styled from 'libs/styled';
import { useSelector } from 'react-redux';

const Div = styled('div')``;

const PaymentWrapper = styled('div')`
    padding: 24px 0;
    border-bottom: 1px solid ${colors.grey4};

    ${above.md} {
        padding: 32px 0;
    }
`;

const AdyenPayment = ({ tracking = {}, displayShipping = true }) => {
    const [showShippingAndPayment, setShowShippingAndPayment] = useState(false);
    const heading = useSelector(state => state.page.data.checkout.payment?.heading);

    const shippingSectionRef = useRef(null);
    const scrollToShippingSection = () => {
        shippingSectionRef.current && scrollTo({ top: !inServer ? shippingSectionRef.current.offsetTop : 0 });
    };

    return (
        <>
            <AdyenFormWrapper
                scrollToShippingSection={scrollToShippingSection}
                setShowShippingAndPayment={setShowShippingAndPayment}
                showShippingAndPayment={showShippingAndPayment}
                tracking={tracking}
            />
            <Div ref={shippingSectionRef}>
                {displayShipping && <ShippingForm showShippingAndPayment={showShippingAndPayment} />}
                <PaymentWrapper as="section" borderTop={!displayShipping && `1px solid ${colors.black}`}>
                    {heading && (
                        <Heading size="md" type={heading.type}>
                            {heading.text}
                        </Heading>
                    )}
                    <Div
                        display={showShippingAndPayment ? 'flex' : 'none'}
                        alignItems="center"
                        flexDirection="column"
                        mt={['24px', null, null, '32px']}
                    >
                        <AdyenDropInContainer
                            render={({ isLoaded: paymentIsLoaded }) => {
                                return !paymentIsLoaded ? <LoadingIcon /> : null;
                            }}
                        />
                        <div id="dropin-container" />
                    </Div>
                </PaymentWrapper>
            </Div>
        </>
    );
};

AdyenPayment.propTypes = {
    displayShipping: PropTypes.bool,
    tracking: PropTypes.shape({
        trigger: PropTypes.bool,
        setTrigger: PropTypes.func,
    }),
};

export default AdyenPayment;
